import { Price } from '@/entities/Order'
import { Currency } from '@/entities/Currency'
import camelcaseKeys from 'camelcase-keys'
import { getTextValue } from '@/lib/helpers/LocalizedText'

export class ReservationMethod {
  constructor (params = {}) {
    const {
      id,
      type,
      active,
      preOrder,
      callToAction,
      allowChildren,
      reservationPrice,
      maximumTimeNotice,
      minimumTimeNotice,
      capacityControlMode,
      mustHaveCheckedIn,
      leewayBeforeCheckIn,
      autoAcceptReservation,
      maximumCapacityPerSlot,
      reservationTimeInterval,
      attendeeTypeConfiguration,
      minimumCancellationTime,
      minimumModificationTime,
      autoAcceptModification,
      minimumOrderUnits,
      leewayTimeBeforeActivityServiceStart,
      activityGroupId,
    } = camelcaseKeys(params, { deep: true })
    this.id = id || null
    this.type = type || null
    this.preOrder = preOrder || null
    this.active = typeof active === 'boolean' ? active : null
    this.attendeeTypeConfiguration = attendeeTypeConfiguration || null
    this.allowChildren = typeof allowChildren === 'boolean' ? allowChildren : null
    this.capacityControlMode = capacityControlMode
    this.maximumTimeNotice = typeof maximumTimeNotice === 'number' ? maximumTimeNotice : null
    this.minimumTimeNotice = typeof minimumTimeNotice === 'number' ? minimumTimeNotice : null
    this.mustHaveCheckedIn = typeof mustHaveCheckedIn === 'boolean' ? mustHaveCheckedIn : null
    this.leewayBeforeCheckIn = typeof leewayBeforeCheckIn === 'number' ? leewayBeforeCheckIn : null
    this.autoAcceptReservation = typeof autoAcceptReservation === 'boolean' ? autoAcceptReservation : null
    this.maximumCapacityPerSlot = typeof maximumCapacityPerSlot === 'number' ? maximumCapacityPerSlot : null
    this.reservationTimeInterval = typeof reservationTimeInterval === 'number' ? reservationTimeInterval : null
    this.callToAction = callToAction ? getTextValue(callToAction) : null
    this.reservationPrice = reservationPrice || []
    this.minimumCancellationTime = minimumCancellationTime
    this.minimumModificationTime = minimumModificationTime
    this.autoAcceptModification = autoAcceptModification || false
    this.minimumOrderUnits = typeof minimumOrderUnits === 'number' ? minimumOrderUnits : null
    this.leewayTimeBeforeActivityServiceStart = typeof leewayTimeBeforeActivityServiceStart === 'number' ? leewayTimeBeforeActivityServiceStart : null
    this.activityGroupId = activityGroupId || null
  }

  decorateCurrencies (currencies) {
    return {
      ...this,
      reservationPrice: this.reservationPrice.map((pricingGroup) => {
        return {
          ...pricingGroup,
          prices: pricingGroup.prices.map((priceArray) => {
            return priceArray.map((priceItem) => {
              const currency = new Currency(currencies.find(c => c.id === priceItem.currencyId))
              return new Price({ ...priceItem, currency })
            })
          }),
        }
      }),
    }
  }
}

export class AttendeeType {
  constructor (params = {}) {
    const {
      id,
      name,
      active,
      guestTypeIds,
      attendeePrices,
      inputDisplayText,
      reservationMethodId,
      maxAttendeesPerReservation,
    } = camelcaseKeys(params, { deep: true })
    this.id = id || null
    this.guestTypeIds = guestTypeIds || []
    this.attendeePrices = attendeePrices ? attendeePrices.map(item => {
      return { pricingGroupId: item.pricingGroupId, prices: item.prices }
    }) : []
    this.reservationMethodId = reservationMethodId || null
    this.active = typeof active === 'boolean' ? active : null
    this.name = name ? getTextValue(name) : null
    this.inputDisplayText = inputDisplayText ? getTextValue(inputDisplayText) : null
    this.maxAttendeesPerReservation = maxAttendeesPerReservation || null
  }

  decorateCurrencies (currencies) {
    return {
      ...this,
      attendeePrices: this.attendeePrices.map((pricingGroup) => {
        return {
          pricingGroupId: pricingGroup.pricingGroupId || null,
          prices: pricingGroup.prices.map((priceArray) => {
            return priceArray.map((priceItem) => {
              const currency = new Currency(currencies.find(c => c.id === priceItem.currencyId))
              return new Price({ ...priceItem, currency })
            })
          }),
        }
      }),
    }
  }
}
